import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export const DashboardModuleStore = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
